(() => {
  function setup(root = document) {
    root.querySelectorAll('.c9m-grid').forEach(grid => {
      if (grid.dataset.c9AreasBound) return;
      grid.dataset.c9AreasBound = 'true';
      const mobile = matchMedia('(max-width: 900px)');
      const syncAreas = () => grid.querySelectorAll('details[data-c9m]').forEach(area => { area.open = !mobile.matches; });
      syncAreas();
      mobile.addEventListener('change', syncAreas);
    });
    const track = root.querySelector('.brand-track');
    root.querySelectorAll('[data-brand]').forEach(button => {
      if (button.dataset.bound) return;
      button.dataset.bound = 'true';
      button.addEventListener('click', () => track?.scrollBy({left: Number(button.dataset.brand) * Math.max(210, track.clientWidth * .7), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'}));
    });

  }
  setup();
  document.addEventListener('shopify:section:load', event => setup(event.target));
})();